import { useEffect, useState } from 'react';

export const useTurnstile = (): Turnstile.Turnstile | null => {
  const [turnstile, setTurnstile] = useState<Turnstile.Turnstile | null>(null);
  useEffect(() => {
    if(window.hasLoadedTurnstile) {
      if(!turnstile) setTurnstile(window.turnstile);
      return;
    }
    window.hasLoadedTurnstile = true;
    const script = document.createElement('script');
    script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback&render=explicit';
    window.onloadTurnstileCallback = () => {
      setTurnstile(window.turnstile);
    };
    document.body.appendChild(script);
  }, []);
  return turnstile;
};

type UseTurnstileRenderReturn = {
  reset: () => void,
};

export const useTurnstileRender = (
  turnstile: Turnstile.Turnstile,
  turnstileSiteKey: string,
  turnstileContainerRef: React.MutableRefObject<any>,
  callback: ((token: string) => void | Promise<void>),
  theme: Turnstile.Theme = 'dark',
): UseTurnstileRenderReturn => {
  const [turnstileHandle, setTurnstileHandle] = useState<string | null | undefined>();

  useEffect(() => {
    if(turnstileContainerRef?.current && turnstile) {
      const widgetId = turnstile.render(
        turnstileContainerRef?.current, {
          sitekey: turnstileSiteKey,
          theme,
          callback,
        }
      );
      setTurnstileHandle(widgetId);
    }

    return () => {
      if(turnstileHandle !== null) {
        turnstile?.remove(turnstileHandle);
      }
    };
  }, [turnstileContainerRef.current, turnstile]);

  return {
    reset: (): void => {
      if(turnstileHandle) {
        turnstile.reset(turnstileHandle);
      }
    },
  };
};
